import { createStore, combineReducers } from "redux";
import { OrderReducer } from "./Orders/orderReducer";
import { searchReducer } from "./General/searchReducer";
import { loginReducer } from "./Login/LoginReducer";
import { generalReducer } from "./General/generalReducer";
import { managementReducer } from "./system_management/ManagmentReducer";
const rootReducer = combineReducers({
  OrderReducer,
  
  searchReducer,
  loginReducer,
  managementReducer,
  generalReducer,
});

const Store = createStore(rootReducer);

export default Store;
